import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';

const V2Firestopping = () => {
  useSEO({
    title: 'Firestopping software | SafeTrace + Business Dashboard',
    description: 'Videra firestopping solutions for surveying, remediating, verifying and managing passive fire protection — SafeTrace and the Firestopping Business Dashboard.',
    path: '/firestopping',
  });

  return (
    <div data-testid="v2-firestopping">
      <ProductHero
        eyebrow="Firestopping"
        title="Firestopping technology built around the work."
        body="Videra's firestopping solutions are designed around the realities of surveying, recording, remediating, verifying and managing passive fire protection. Choose the level of control your organisation needs."
        testid="firestopping-hero"
      />

      <section className="py-16 md:py-24 bg-slate-50 border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link to="/firestopping/safetrace" className="group bg-white border border-slate-200 hover:border-slate-900 rounded-xl p-8 hover:shadow-lg transition-all" data-testid="firestopping-card-safetrace">
            <p className="text-[11px] uppercase tracking-[0.22em] text-blue-600 font-semibold">SafeTrace</p>
            <h3 className="mt-2 text-2xl font-medium text-slate-900 group-hover:text-blue-700 transition-colors">Firestopping evidence you can trust.</h3>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">Standalone firestopping survey, remediation, verification and evidence platform. Available independently.</p>
            <p className="mt-6 inline-flex items-center text-sm font-medium text-blue-600">Explore SafeTrace <ArrowRight className="ml-1 w-4 h-4" /></p>
          </Link>
          <Link to="/firestopping/business-dashboard" className="group bg-white border border-slate-200 hover:border-slate-900 rounded-xl p-8 hover:shadow-lg transition-all" data-testid="firestopping-card-dashboard">
            <p className="text-[11px] uppercase tracking-[0.22em] text-blue-600 font-semibold">Business Dashboard</p>
            <h3 className="mt-2 text-2xl font-medium text-slate-900 group-hover:text-blue-700 transition-colors">Run the business. Control the work. Prove the installation.</h3>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">A complete operating environment for growing firestopping businesses — from lead through commercial completion. SafeTrace included.</p>
            <p className="mt-6 inline-flex items-center text-sm font-medium text-blue-600">Explore the Business Dashboard <ArrowRight className="ml-1 w-4 h-4" /></p>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default V2Firestopping;
